import React, { useState, useEffect } from 'react';
import { apiFetch } from '../utils/api';
import '../styles/Join.css';

export default function Join() {
  const [recruitmentSettings, setRecruitmentSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRecruitmentSettings();
  }, []);

  const fetchRecruitmentSettings = async () => {
    try {
      setLoading(true);
      const data = await apiFetch('/api/recruitment');
      setRecruitmentSettings(data);
    } catch (err) {
      console.error('Error fetching recruitment settings:', err);
      setError('Failed to load recruitment information');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="join-page">
        <div className="join-header">
          <img src={require('../assets/logo.png')} alt="NHHS Logo" className="join-logo" />
          <div className="join-title">Applications</div>
          <div className="join-subtitle">Loading...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="join-page">
        <div className="join-header">
          <img src={require('../assets/logo.png')} alt="NHHS Logo" className="join-logo" />
          <div className="join-title">Applications</div>
          <div className="join-subtitle">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="join-page">
      <div className="join-header">
        <img src={require('../assets/logo.png')} alt="NHHS Logo" className="join-logo" />
        <div className="join-title">Applications</div>
        <div className="join-subtitle">
          {recruitmentSettings?.isOpen ? (
            <>
              🎉 Applications are now open!<br />
              <span style={{fontWeight:500}}>Ready to join NHHS Analytics?</span>
            </>
          ) : (
            <>
              Thank you for your interest in joining NHHS Analytics.<br />
              Applications are currently closed.<br />
              <span style={{fontWeight:500}}>Application dates will be announced soon.</span>
            </>
          )}
        </div>
      </div>
      
      <div className="join-info-box">
        {recruitmentSettings?.isOpen ? (
          <div className="recruitment-open-content">
            <div className="recruitment-message">
              <p>
                {recruitmentSettings.message || 'Join NHHS Analytics and develop your analytical skills through social courses while connecting with like-minded peers interested in Excel, R, AI, and quantitative finance.'}
              </p>
            </div>
            
            {recruitmentSettings.showAdmissionInfo && (
              <div className="admission-info">
                <h3>Admission Information</h3>
                <div className="admission-details">
                  {recruitmentSettings.deadline && (
                    <div className="admission-item">
                      <strong>Deadline:</strong> {recruitmentSettings.deadline}
                    </div>
                  )}
                  {recruitmentSettings.tryoutStart && (
                    <div className="admission-item">
                      <strong>Try-out start:</strong> {recruitmentSettings.tryoutStart}
                    </div>
                  )}
                  {recruitmentSettings.tryoutEnd && (
                    <div className="admission-item">
                      <strong>Try-out end:</strong> {recruitmentSettings.tryoutEnd}
                    </div>
                  )}
                  {recruitmentSettings.contactEmail && (
                    <div className="admission-item">
                      <strong>Contact:</strong> <a href={`mailto:${recruitmentSettings.contactEmail}`} className="contact-link">{recruitmentSettings.contactEmail}</a>
                    </div>
                  )}
                </div>
              </div>
            )}
            
            {recruitmentSettings.googleFormUrl && (
              <div className="apply-button-container">
                <a 
                  href={recruitmentSettings.googleFormUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="apply-button"
                >
                  Apply Now →
                </a>
              </div>
            )}
          </div>
        ) : (
          <div className="recruitment-closed-content">
            <p>
              We open for new members periodically throughout the year.<br />
              Please check back here or follow us on social media for updates.
            </p>
            <p>
              If you have questions, feel free to <a href="/contact" className="contact-link">contact us</a>.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
